import type { PublicPluginAPI, NextEditorPlugin, EditorCommand } from '@atlaskit/editor-common/types';
import type { AnalyticsPlugin } from '@atlaskit/editor-plugin-analytics';
import type { ConfluenceUpdateDynamicUiOnPageData } from '@atlassian/rovo-content-bridge-api-commands/commands/confluence-update-page-command';

interface ReplaceMauiAppProps {
	newMauiId: string;
	previousMauiId: string;
};

/**
 * This is a copy of a subset of the public API of @atlassian/editor-plugin-malleable-ui.
 * It is required due to public-private package visibility issues.
 */
type MalleableUiPlugin = NextEditorPlugin<
	'malleableUi',
	{
		commands: {
			replaceMauiApp: (props: ReplaceMauiAppProps) => EditorCommand;
		};
	}
>;

export class DocumentDynamicUiUpdateCommandProcessor {
	constructor(
		private editorApi: PublicPluginAPI<[AnalyticsPlugin, MalleableUiPlugin]>,
	) { }

	streamChunk(
		data: ConfluenceUpdateDynamicUiOnPageData,
		isFinished: boolean,
		_traceId?: string,
		_singleInstrumentationId?: string,
	): void {
		if (isFinished) {
			this.editorApi.core.actions.execute(
				this.editorApi.malleableUi?.commands.replaceMauiApp({
					previousMauiId: data.previousMauiId,
					newMauiId: data.id,
				}),
			);
			return;
		}
	}
}